const reportConstants = {
  REPORT_TYPE: {
    'Session Count Reports': 'session-count',
    'Session Details Reports': 'session-detail',
    'User Reports': 'user',
  },

  ENTITY_TYPE: {
    Organization: 'organization',
    Network: 'network',
    Group: 'group',
  },

  REPORT_JOB_STATUS: {
    QUEUED: 'queued',
    RUNNING: 'running',
    READY: 'ready',
    ERROR: 'error',
    FAILED: 'failed',
  },

  // Poll async report jobs until ready / error
  POLL_INTERVAL_MS: 2000,
  POLL_MAX_ATTEMPTS: 90,
}

export default reportConstants
